import { render } from "./PealinnadeMäng.vue?vue&type=template&id=602e3746&scoped=true"
import script from "./PealinnadeMäng.vue?vue&type=script&lang=js"
export * from "./PealinnadeMäng.vue?vue&type=script&lang=js"

import "./PealinnadeMäng.vue?vue&type=style&index=0&id=602e3746&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602e3746"]])

export default __exports__